export const LOFT_START_MARK = 'loft/start'

export class PerformanceEntry {
  static MARK = 'mark'
  static MEASURE = 'measure'

  constructor(entryType, name, startTime, duration = 0) {
    this.entryType = entryType
    this.name = name
    this.startTime = startTime || performance.now()
    this.duration = duration
  }
}

export class Performance {
  entries = {}

  mark(name = Math.random().toString(36)) {
    const entry = new PerformanceEntry(PerformanceEntry.MARK, name)

    if (!Array.isArray(this.entries[name])) {
      this.entries[name] = []
    }

    this.entries[name].push(entry)
    return entry
  }

  measure(from, to) {
    const measureName = `${from}:${to}`

    const fromMark = [...this.entries[from]].pop()
    const toMark = [...this.entries[to]].pop()

    return new PerformanceEntry(
      PerformanceEntry.MEASURE,
      measureName,
      performance.now(),
      toMark.startTime - fromMark.startTime
    )
  }

  measureFrom(from) {
    const markName = Math.random().toString(36)
    return this.measure(from, this.mark(markName).name)
  }
}

export default new Performance()
